const GET_COUNTRIES = 'GET_COUNTRIES';
const GET_COUNTRIES_BY_NAME = 'GET_COUNTRIES_BY_NAME';
const GET_COUNTRIES_BY_CODE = 'GET_COUNTRIES_BY_CODE';

export {
    GET_COUNTRIES,
    GET_COUNTRIES_BY_NAME,
    GET_COUNTRIES_BY_CODE
}